import { Utils } from "custom";

/**
 * CHI PUÒ VEDERE L'ESTRAZIONE VERSO ATOM.
 *
 * ┌─ ⚠️ QUESTO È UN FILTRO DELLA SCHERMATA, NON UNA SERRATURA ───────────────────────────┐
 * │                                                                                      │
 * │ Serve a non mettere davanti agli occhi di ventisei amministratori un pulsante che     │
 * │ scarica l'anagrafica di tutti i corsisti. La porta la chiude il backend               │
 * │ (`exportAtom.routes.js`, `soloChiPuo`): lì l'elenco è lo stesso e risponde 403 a       │
 * │ chiunque non ci sia, anche se arriva all'indirizzo scrivendolo a mano.                │
 * │                                                                                      │
 * │ Le due copie dell'elenco non sono una svista: una decide cosa si VEDE, l'altra cosa   │
 * │ si PUÒ. Tenerne una sola vorrebbe dire o chiedere al server prima di disegnare un     │
 * │ menu, o fidarsi del browser per una cosa di cui non ci si può fidare.                 │
 * └──────────────────────────────────────────────────────────────────────────────────────┘
 *
 * Si cambia con `REACT_APP_EXPORT_ATOM_EMAILS` (separate da virgola). Se cambi qui, cambia
 * anche `EXPORT_ATOM_EMAILS` sul backend: è quello che conta.
 */
const AMMESSI = String(process.env.REACT_APP_EXPORT_ATOM_EMAILS
    || "federicobrocco.dev@gmail.com,mario.mammarella997@gmail.com")
    .split(",")
    .map((e) => e.trim().toLowerCase())
    .filter(Boolean);

/** Vero se l'utente che sta guardando può usare l'estrazione. */
export function puoEsportare() {
    try {
        const dati = Utils.getUserData();
        if (!dati || dati.role !== "ADMIN") return false;

        const mia = String(dati.email || "").trim().toLowerCase();
        return !!mia && AMMESSI.indexOf(mia) !== -1;
    } catch (e) {
        // Nel dubbio, non si vede: è l'unica direzione in cui sbagliare non costa niente.
        return false;
    }
}

export default AMMESSI;
